var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import config from "@/config";
var CoreButton = /** @class */ (function (_super) {
    __extends(CoreButton, _super);
    function CoreButton(scene, x, y, key, hoverkey, text, textHeigt, fontSize, callback, scale, icons) {
        if (scale === void 0) { scale = 1; }
        var _this = _super.call(this, scene, x, y, key) || this;
        _this.scene.add.existing(_this);
        _this._scale = scale;
        _this.setInteractive({
            useHandCursor: true,
        });
        _this.on("pointerdown", function () {
            callback();
        });
        _this.on("pointerover", function () {
            _this.setScale(_this._scale + 0.025);
        });
        _this.on("pointerout", function () {
            _this.setScale(_this._scale);
        });
        _this.title = new Phaser.GameObjects.Text(scene, _this.x, _this.y + textHeigt, text.toUpperCase(), {
            align: "center",
            color: "white",
            fontFamily: config.graphics.fontFamily,
        })
            .setFontSize(fontSize)
            .setOrigin(0.5);
        _this.scene.add.existing(_this.title);
        if (icons === null || icons === void 0 ? void 0 : icons.left) {
            _this.icon_left = new Phaser.GameObjects.Image(scene, _this.x - _this.width / 2 + 82, _this.y + textHeigt, icons.left).setOrigin(0, 0.5);
            _this.scene.add.existing(_this.icon_left);
        }
        if (icons === null || icons === void 0 ? void 0 : icons.right) {
            _this.icon_right = new Phaser.GameObjects.Image(scene, _this.x + _this.width / 2 - 102, _this.y + textHeigt, icons.right).setOrigin(0.5, 0.5);
            _this.scene.add.existing(_this.icon_right);
        }
        _this.setScale(_this._scale, _this._scale, true);
        _this.setOrigin(0.5);
        _this.setScrollFactor(0);
        _this.setDepth(99999);
        return _this;
    }
    CoreButton.prototype.setAlpha = function (topLeft, topRight, bottomLeft, bottomRight) {
        var _a, _b;
        _super.prototype.setAlpha.call(this, topLeft, topRight, bottomLeft, bottomRight);
        this.title.setAlpha(topLeft, topRight, bottomLeft, bottomRight);
        (_a = this.icon_left) === null || _a === void 0 ? void 0 : _a.setAlpha(topLeft, topRight, bottomLeft, bottomRight);
        (_b = this.icon_right) === null || _b === void 0 ? void 0 : _b.setAlpha(topLeft, topRight, bottomLeft, bottomRight);
        return this;
    };
    CoreButton.prototype.setPosition = function (x, y, z, w) {
        var _a, _b, _c;
        _super.prototype.setPosition.call(this, x, y, z, w);
        (_a = this.title) === null || _a === void 0 ? void 0 : _a.setPosition(x, y - this.title.displayHeight / 2, z, w);
        (_b = this.icon_left) === null || _b === void 0 ? void 0 : _b.setPosition(this.title.x -
            this.title.displayWidth / 2 -
            this.icon_right.displayWidth / 2 -
            10, this.title.y, z, w);
        (_c = this.icon_right) === null || _c === void 0 ? void 0 : _c.setPosition(this.title.x +
            this.title.displayWidth / 2 +
            this.icon_right.displayWidth / 2 +
            10, this.title.y, z, w);
        return this;
    };
    CoreButton.prototype.setScale = function (x, y, override) {
        var _a, _b;
        if (override) {
            this._scale = x;
        }
        var coef = 0.1;
        var _x = x * coef;
        var _y = (y || x) * coef;
        _super.prototype.setScale.call(this, x, y);
        this.title.setScale(x, y);
        (_a = this.icon_left) === null || _a === void 0 ? void 0 : _a.setScale(_x, _y);
        (_b = this.icon_right) === null || _b === void 0 ? void 0 : _b.setScale(_x, _y);
        return this;
    };
    CoreButton.prototype.setDepth = function (value) {
        var _a, _b;
        _super.prototype.setDepth.call(this, value);
        this.title.setDepth(value + 1);
        (_a = this.icon_left) === null || _a === void 0 ? void 0 : _a.setDepth(value + 1);
        (_b = this.icon_right) === null || _b === void 0 ? void 0 : _b.setDepth(value + 1);
        return this;
    };
    CoreButton.prototype.setScrollFactor = function (x, y) {
        var _a, _b;
        _super.prototype.setScrollFactor.call(this, x, y);
        this.title.setScrollFactor(x, y);
        (_a = this.icon_left) === null || _a === void 0 ? void 0 : _a.setScrollFactor(x, y);
        (_b = this.icon_right) === null || _b === void 0 ? void 0 : _b.setScrollFactor(x, y);
        return this;
    };
    CoreButton.prototype.setVisible = function (value) {
        var _a, _b;
        _super.prototype.setVisible.call(this, value);
        this.title.setVisible(value);
        (_a = this.icon_left) === null || _a === void 0 ? void 0 : _a.setVisible(value);
        (_b = this.icon_right) === null || _b === void 0 ? void 0 : _b.setVisible(value);
        return this;
    };
    return CoreButton;
}(Phaser.GameObjects.Sprite));
export default CoreButton;
